export default {
  "Cut Audio": "Couper l'audio",
  "HitPaw Online Audio Cutter": "HitPaw coupeur d'audio en ligne",
  "Trim or cut any audio files online.": "Divisez ou coupez tous les fichiers audio en ligne.",
  "Cut": "Couper",
  "Fade in": "Faire effondrer le son",
  "Fade out": "Faire disparaître le son",
  "Cut from": "Couper de",
  "to": "à",
  "Extract selection": "Extraire la sélection",
  "Delete selection": "Supprimer la sélection",
  "Adjust New": "Ajuster à nouveau",
  "Cut New": "Couper de nouveau",
  "Adjust Volume": "Ajuster le volume",
  "HitPaw Online Volume Changer": "HitPaw changeur de volume en ligne",
  "Turn up or Turn down the volume of audio.": "Augmenter ou abaisser le volume de l'audio.",
  "Volume": "Le volume",
  "Change Speed": "Changement de vitesse",
  "HitPaw Online Audio Speed Changer": "HitPaw changeur de vitesse audio en ligne",
  "Speed up or slow down audios online easily.": "Accélérer ou ralentir les audios en ligne facilement.",
  "Speed": "La vitesse",
  "Format": "Format",
  "Size": "Taille",
  "Duration": "Durée",
};
